import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import useZohoMcpUnlocker from './useZohoMcpUnlocker'
import { SIZE } from 'baseui/input'

const ZohoMcpUnlocker = () => {
  const { unlockZohoMcp, mcpUnlockError, isAdmin, isMcpClient, isMcpLocked, config, blockedForAgent, t } =
    useZohoMcpUnlocker()

  if (!isMcpClient || !config.mcp) return null

  if (!isMcpLocked) {
    const message = isAdmin
      ? t('subscriptionForm:zoho_module.unblock_mcp_unlocked_admin')
      : t('subscriptionForm:zoho_module.unblock_mcp_unlocked_agent')
    return <SDNotification type='positive' primaryText={message} iconType='unlocked' />
  }

  if (!isAdmin) {
    if (blockedForAgent) {
      const message =
        t('subscriptionForm:zoho_module.unblock_mcp_bold_is_mcp') +
        t('subscriptionForm:zoho_module.unblock_mcp_ask_admin')
      return <SDNotification type='negative' primaryText={message} iconType='warning' />
    }
    return (
      <SDNotification
        type='positive'
        primaryText={t('subscriptionForm:zoho_module.unblock_mcp_bold_is_mcp')}
        icon={false}
      />
    )
  }

  return (
    <>
      <SDNotification
        type='warning'
        iconType='locked'
        primaryText={t('subscriptionForm:zoho_module.unblock_mcp_text_admin')}
      >
        <SDButton
          size={SIZE.compact}
          block={false}
          style={{ width: '100%', margin: '1rem 0 0 0' }}
          onClick={unlockZohoMcp}
        >
          {t('subscriptionForm:zoho_module.unblock_mcp_zoho_label_for_admin')}
        </SDButton>
      </SDNotification>
      {mcpUnlockError && <p>{mcpUnlockError}</p>}
    </>
  )
}

export default ZohoMcpUnlocker
